import { debounce } from 'lodash-es';
import SyosEvents from './utils/SyosEvents';
import { templateSeatInfoPopover } from './templates/templates';
import SyosUiContainer from './SyosUiContainer';
import { clamp } from './utils/math';

const HTML = `
  <div class="tn-syos-seat-info-popover__content-container"></div>
`;

const MARGIN = 10;

class SyosSeatInfoPopover extends SyosUiContainer {

  constructor(syosController) {
    super(syosController, '.tn-syos-seat-info-popover');

    this.bindMethods();
    this.seat = null;
    this.currentPricetypeSelectorSeat = null;
    this.show = debounce(this.show, 250);

    this.$el.hide();
    this.$el.html(HTML);

    this.$container = this.find('.tn-syos-seat-info-popover__content-container');

    this.syosController.on(SyosEvents.SEAT_MOUSE_OVER, this.onSeatMouseOver);
    this.syosController.on(SyosEvents.SEAT_MOUSE_LEAVE, this.hide);
    this.syosController.on(SyosEvents.SEAT_MOUSE_PRESS, this.onSeatPress);
    this.syosController.on(SyosEvents.SEAT_CLICK, this.hide);
    this.syosController.on(SyosEvents.SCREEN_UPDATED, this.hide);
  }

  bindMethods() {
    this.onSeatMouseOver = this.onSeatMouseOver.bind(this);
    this.onSeatPress = this.onSeatPress.bind(this);
    this.hide = this.hide.bind(this);
  }

  onSeatPress({ seat }) {
    if (seat !== this.seat) {
      this.hide();
    }
  }

  onSeatMouseOver({ seat }) {
    if (seat.getIsViewingInPriceTypeSelector()) {
      return;
    }

    this.seat = seat;

    const data = this.seat.getTemplateData();
    const html = templateSeatInfoPopover.render(data);

    this.$container.html(html);
    this.show();
  }

  show() {
    if (this.seat === null) {
      return;
    }

    this.$el.show();

    const seatRect = this.seat.getClientRect();
    const popoverRect = this.$container[0].getBoundingClientRect();

    const { clientWidth: viewportWidth, clientHeight: viewportHeight } = document.documentElement;

    const minPopoverX = MARGIN;
    const minPopoverY = MARGIN;
    const maxPopoverX = viewportWidth - popoverRect.width - MARGIN;
    const maxPopoverY = viewportHeight - popoverRect.height - MARGIN;

    let x;
    let y;

    const centeredX = clamp(
      (seatRect.left + (seatRect.width * 0.5)) - (popoverRect.width * 0.5),
      minPopoverX,
      maxPopoverX,
    );

    const centeredY = clamp(
      (seatRect.top + (seatRect.height * 0.5)) - (popoverRect.height * 0.5),
      minPopoverY,
      maxPopoverY,
    );

    if (seatRect.top - popoverRect.height - MARGIN >= minPopoverY) {
      // Above
      x = centeredX;
      y = seatRect.top - popoverRect.height - MARGIN;
    } else if (seatRect.right + MARGIN <= maxPopoverX) {
      // Right
      x = seatRect.right + MARGIN;
      y = centeredY;
    } else if (seatRect.left - popoverRect.width - MARGIN >= minPopoverX) {
      // Left
      x = seatRect.left - popoverRect.width - MARGIN;
      y = centeredY;
    } else {
      // Bottom
      x = centeredX;
      y = seatRect.bottom + MARGIN;
    }

    this.$container.css({
      left: `${Math.round(x)}px`,
      top: `${Math.round(y)}px`,
      opacity: 0,
      transition: 'none',
    });

    window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        if (this.seat === null) {
          return;
        }

        this.$container.css({
          opacity: '1',
          transition: 'opacity 0.1s ease-out',
        });
      });
    });
  }

  hide() {
    this.seat = null;
    this.$el.hide();
  }
}

export default SyosSeatInfoPopover;



// WEBPACK FOOTER //
// ./V7/syos/SyosSeatInfoPopover.js